module.exports = __webpack_public_path__ + "img/基站定位-bj.ad60182a.png";